export const enCustomerViewTranslations = {
  CustomerView: {
    menuLabel: 'Customer view',
    menuDescription:
      'Hide staff tools on this browser, for demos and training. Turns off by itself after 12 hours.',
    indicatorLabel: 'Customer view is on',
    profileLabel: 'Clinician Profile · Customer view is on',
  },
};
